import {Button, Col, Form, message, Popover, Row, TableColumnsType, Typography} from "antd";
import {useEffect, useRef, useState} from "react";
import {wdiCore, WdiModalAppProps, WdiTextArea} from "@/components/WdiControls";
import {WdiTable} from "@/components/WdiControls/WdiTable";
import {WdiModalForm} from "@/components/WdiControls/WdiModalForm";
import {Enum} from "@/enums/system";
import {ResponseStatus} from "@/utils/request";
import {ProductPolicy} from "@/services/policy/productpolicy";
import RebateStandardOptsInput from "@/pages/policy/ProductPolicyApply/components/rebateStandardOptsInput";
import {ProFormInstance} from "@ant-design/pro-form";
import {OpenModeEnum} from "@/pages/policy/ProductPolicyApply/components/apply";
import React from "react";

export type RebateStandardProps = {
  value?: API.ProductPolicyRate[];
  onChange?: (result: API.ProductPolicyRate[]) => void;
  onClose?: () => void;
  columns?: TableColumnsType<API.ProductPolicyRate>;
  initialFormulaRebateIsRequired?: boolean;
  openMode?: OpenModeEnum
}


const RebateStandardApp: React.FC<RebateStandardProps> = (props: RebateStandardProps) => {
  const [rebateStandardModalProps, setRebateStandardModalProps] = useState<WdiModalAppProps>({visible: false});

  const columns: TableColumnsType<API.ProductPolicyRate> = [
    {
      title: '行号',
      dataIndex: 'rowNumber',
      width: 100,
    },
    {
      title: '达量条件',
      dataIndex: 'conditionReach',
    },
    {
      title: '返利公式',
      dataIndex: 'formulaRebate',
    },
    {
      title: '条款备注',
      dataIndex: 'remarkRebate',
    },
  ];

  return (<>
    {rebateStandardModalProps.visible &&
      <RebateStandardEditApp
        {...props}
        columns={columns}
        onClose={() => {
          setRebateStandardModalProps({visible: false})
        }}
      />
    }

    <Button hidden={props.openMode === OpenModeEnum.VIEW || props.openMode === OpenModeEnum.UPDATE_PARTLY}
            type="link"
            style={{position: 'absolute', top: '-35px', right: '0'}}
            onClick={() => setRebateStandardModalProps({visible: true})}>
      维护
    </Button>

    <WdiTable columns={columns} dataSource={props.value ?? []}/>
  </>)
};

const RebateStandardEditApp: React.FC<RebateStandardProps> = (props) => {

  let lastBlurAreaRef: any = null;
  let lastBlurFunc: any = null;

  const optArray = [' + ', ' - ', ' * ', ' / ', '(', ')', ' = ', ' > ', ' < ', ' >= ', ' <= ', ' != ', ' AND ', ' OR ', 'Round()', 'Min()', '@'];

  const {Paragraph} = Typography;
  const formRef = useRef<ProFormInstance>();
  const [allParameters, setAllParameters] = useState<API.ExpressionTypeParameterVo>({
    conditionReach: [],
    formulaRebate: [],
    formulaReimburse: []
  });
  const [rebateStandard, setRebateStandard] = useState<API.ProductPolicyRate[]>([]);
  const [lastLegalRowIndex, setLastLegalRowIndex] = useState<number>(0);
  const [initFormulaRebate, setInitFormulaRebate] = useState<string | undefined>('');
  const [showMore, setShowMore] = useState<boolean>(false);
  const length = 10


  useEffect(() => {
    for (let i = 0; i < length; i++) {
      rebateStandard.push({rowNumber: i + 1})
    }
    setRebateStandard(rebateStandard.slice())
    ProductPolicy.getProductPolicyParameter({}).then(response => {
      setAllParameters(response?.data ?? [])
    })
  }, []);

  useEffect(() => {
    if (props.value) {
      props.value.forEach((item: API.ProductPolicyRate) => {
        if (!item.rowNumber) return;
        if (item.conditionReach == '初始预提公式') {
          setInitFormulaRebate(item.formulaRebate);
          formRef.current?.setFieldsValue({initFormulaRebate: item.formulaRebate})
          return;
        }
        rebateStandard[item.rowNumber - 1] = Object.assign(rebateStandard[item.rowNumber - 1], item)
      })
      setRebateStandard(rebateStandard.slice())
    }
  }, [props.value]);

  useEffect(() => {
    let maxRowIndex = 0;
    rebateStandard.filter((value, index) => {
      if (!wdiCore.String.IsNullOrEmpty(value.conditionReach) || !wdiCore.String.IsNullOrEmpty(value.formulaRebate)
        || !wdiCore.String.IsNullOrEmpty(value.formulaReimburse) || !wdiCore.String.IsNullOrEmpty(value.remarkRebate)) {
        if (maxRowIndex < index && index < length) {
          maxRowIndex = index;
        }
      }
    })
    setLastLegalRowIndex(maxRowIndex);
  }, [rebateStandard])

  const ruleCheck = (row: any, index: number) => {
    if (index <= lastLegalRowIndex) {
      return true;
    }
    if (!wdiCore.String.IsNullOrEmpty(row?.rebateExpression) || !wdiCore.String.IsNullOrEmpty(row?.reachExpression)) {
      return true;
    }
    return false;
  }

  const getParameter = (col: any) => {
    let parameters: API.ProductPolicyParameter[] = [];
    if (col.dataIndex == 'conditionReach') {
      parameters = allParameters.conditionReach
    }
    if (col.dataIndex == 'formulaRebate') {
      parameters = allParameters.formulaRebate;
    }
    if (col.dataIndex == 'formulaReimburse') {
      parameters = allParameters.formulaReimburse;
    }
    return parameters;
  }

  const onClickOptStr = (e: any) => {
    if (lastBlurFunc == null || lastBlurAreaRef == null) {
      message.warn("聚焦输入框后, 点击符号自动添加");
      return;
    }
    lastBlurFunc(e.currentTarget.textContent, lastBlurAreaRef);
  }

  return (


    <WdiModalForm
      formRef={formRef}
      title={"新建/编辑返利标准"}
      visible={true}
      onFinish={async () => {
        const policyParam: API.ProductPolicy = {
          policyType: Enum.PolicyType.AUTO_CALC,
        };
        let productPolicyRates = rebateStandard.filter(item => item.formulaRebate);
        if (!wdiCore.String.IsNullOrEmpty(initFormulaRebate)) {
          productPolicyRates.push({
            rowNumber: productPolicyRates.length + 1,
            conditionReach: '初始预提公式',
            formulaRebate: initFormulaRebate
          });
          policyParam.formulaRebateOriginal = initFormulaRebate;
        }
        const res = await ProductPolicy.Buttons.validateRebateStandard({
          productPolicy: policyParam,
          productPolicyRates: productPolicyRates
        })
        if (res && res.code != ResponseStatus.SUCCESS) {
          message.error(res.message);
          return;
        }

        res.data.forEach((item: API.ProductPolicyRate) => {
          if (item.conditionReach == '初始预提公式') {
            item.isInit = true;
          }
        })

        props.onChange?.(res.data)
        props.onClose?.()
      }}
      modalProps={{
        onCancel: () => {
          props.onClose?.()
        },
        destroyOnClose: true,
        maskClosable: false,
        centered: true
      }}
      width={1000}
      overflowY={showMore ? 'auto' : 'hidden'}
      bodyHeight={props.initialFormulaRebateIsRequired ? 810 : 715}
    >


      <Row gutter={[16, 0]} style={{
        position: 'sticky',
        top: '0',
        backgroundColor: '#fff',
        zIndex: 1,
        borderBottom: '1px solid #f2f2f2'
      }}>
        <Col className="gutter-row" span={24}>
          <Paragraph>
            可选符号：
            {
              optArray.map((item, index) => {
                return <a className="optStr" onClick={onClickOptStr}
                          style={{fontWeight: 'bold', fontSize: '15px', padding: '10px'}}>{item}</a>
              })
            }
            <Popover placement="topLeft" content={
              <div>
                <Paragraph>可选符号可点击；在达量条件或者返利公式文本框内输入@进行参数选择</Paragraph>
              </div>
            }>
              <a style={{float: 'right', marginRight: 15}}>注意事项</a>
            </Popover>
          </Paragraph>
        </Col>
        <Col className="gutter-row" span={24}>
          <Paragraph style={{color: 'red'}}>
            注意：返利坎级由大到小维护，坎级最大维护在返利公式1中
          </Paragraph>
        </Col>
      </Row>

      <div
        className="formListDiv"
        style={{height: showMore ? 1080 : 520, width: '100%', overflowX: 'hidden', overflowY: 'hidden'}}
      >
        <Form.List initialValue={rebateStandard} name={'rebateStandard'}>
          {
            root => (
              root.map((obj, index) => {
                const row: any = rebateStandard[index];
                return <Row key={index} gutter={[16, 24]}>
                  {
                    props.columns?.filter((item: any) => {
                      return ['conditionReach', 'formulaRebate', 'remarkRebate'].includes(item.dataIndex)
                    }).map((item: any) => {
                      if (item.dataIndex == 'remarkRebate') {
                        return <Col className="gutter-row" flex={'30%'} key={item.dataIndex}>
                          <Form.Item
                            rules={[{required: ruleCheck(row, index)}]}
                            label={item.title + row.rowNumber}
                            name={[obj.name, item.dataIndex]}
                          >
                            <WdiTextArea
                              style={{ resize: 'none' }}
                              onChange={(result) => {
                                row[item.dataIndex] = result?.target?.value;
                                setRebateStandard(rebateStandard.slice())
                              }}
                              autoSize={false}
                            />
                          </Form.Item>
                        </Col>
                      }
                      return <Col className="gutter-row" flex={'35%'} key={item.dataIndex}>
                        <Form.Item
                          rules={[{
                            required: ruleCheck(row, index),
                            message: item.title + row.rowNumber + '不能为空！'
                          }]}
                          label={item.title + row.rowNumber}
                          name={[obj.name, item.dataIndex]}>
                          <RebateStandardOptsInput
                            onChange={(result) => {
                              row[item.dataIndex] = result;
                              setRebateStandard(rebateStandard.slice())
                            }}
                            onBlur={(func, textAreaRef) => {
                              lastBlurFunc = func;
                              lastBlurAreaRef = textAreaRef;
                            }}
                            parameters={getParameter(item)}
                            rowNumber={row.rowNumber}
                          />
                        </Form.Item>
                      </Col>
                    })
                  }
                </Row>

              })
            )
          }
        </Form.List>
      </div>

      <Button type={'link'} hidden={showMore} onClick={() => setShowMore(true)}>{'更多条件'}</Button>

      <Row key={5} gutter={[16, 24]}>
        <Col className="gutter-row" flex={'70%'} key={'initFormulaRebate'}>
          <Form.Item
            rules={[{
              required: props.initialFormulaRebateIsRequired ?? false,
              message: '初始预提公式不能为空！'
            }]}
            label={'初始预提公式（若结案频率大于1则必填）'}
            name={'initFormulaRebate'}>
            <RebateStandardOptsInput
              onChange={(result) => {
                setInitFormulaRebate(result);
              }}
              onBlur={(func, textAreaRef) => {
                lastBlurFunc = func;
                lastBlurAreaRef = textAreaRef;
              }}
              parameters={getParameter({dataIndex: 'formulaRebate'})}
              rowNumber={5}
            />
          </Form.Item>
        </Col>
      </Row>
    </WdiModalForm>

  )
}

export default RebateStandardApp;
